import { ReactNode } from 'react';
import Footer from '@/shared/components/Footer';

interface Props {
  children: ReactNode;
  centered?: boolean;
}

export default function PublicLayout({ children, centered = false }: Props) {
  return (
    <div
      className={`min-h-screen min-h-[100dvh] bg-white flex flex-col ${centered ? 'justify-center' : ''}`}
    >
      <div className={`mx-auto max-w-7xl px-0 sm:px-6 lg:px-8 flex-1 ${centered ? 'py-2 sm:py-8 flex items-center' : 'pt-0 pb-4 sm:py-8 lg:py-16'}`}>
        {children}
      </div>
      <Footer />
    </div>
  );
}
